import gql from 'graphql-tag';


export const GET_DATASOURCE_LOOKUP_BY_ID = gql(`
query($id: Int!) {
    dataSourceLookUpQuery {
      getById(id:$id) {
        id,
        dataSourceId,
        idFieldLinked,
        idFieldDescription,
        tableAlias,
        maxRowsReturned
        queryDisplay,
        queryWhere,
        queryOrder,        
        addNewvaluesOnTheFly,
        additionaFieldsOnSearch
        fieldsOnReturn
        idControlType,
        componentId,
        iapDataSourceLookUpFieldMaps{
            id,
            dataSourceFieldIdSource,
            dataSourceFieldIdTarget,
            dataSourceLookUpId
            isFieldLinked
        }
        dataSource{
            id,
            applicationId,
            applicationVersion,
            idDataSourceType,
            name,
            description,
            iapDataSourceFields{

                          id
                          dataSourceId
                          dataSourceTableAliasId
                          tableName
                          field
                          tableNameAlias
                          fieldAlias
                          primaryKey                
                          foreignKey
                          identityColumn
                          position
                          defaultValue
                          nullable
                          encrypted
                          sqlType
                          length
                          precision
                          idDataType
                          catalogTypeId
                          foreignTableName
                          foreignTableFieldId
                          foreignTableFieldDescription
                          dataSourceLookUpId
                          shortDescription
                          description
                          fcr
                          ucr
                          uum
                          fum
            }
        }

        
      }
    }
}
`);
